import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
	LWApiPublicProjectAddParamsRawI,
	LWApiPublicProjectAddResultRawI,
} from '@liquidweb-dev/club-sauce/public/project/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';
import { ASSET_LIST_QUERY_KEY } from 'modules/queries/asset/useList';
import useSnackbarError from 'utility/hooks/useSnackbarError';
import { PROJECT_DETAILS_QUERY_KEY } from './useDetails';

const useProjectAdd = () => {
	const queryClient = useQueryClient();
	const snackbarError = useSnackbarError();

	return useMutation<
		LWApiPublicProjectAddResultRawI,
		ApiErrorI,
		LWApiPublicProjectAddParamsRawI
	>({
		mutationFn: (params) => api.project.apiRaw.add(params),
		onSuccess: (_data, variables) => {
			queryClient.invalidateQueries({
				queryKey: [PROJECT_DETAILS_QUERY_KEY, { id: variables.id }],
			});

			queryClient.invalidateQueries({
				queryKey: [ASSET_LIST_QUERY_KEY],
			});
		},
		onError: snackbarError,
	});
};

export default useProjectAdd;
